import { api } from '@ezugi/utils';

import { GET_USER_URL } from '../../../endpoints';

type UserResponse = {
  result: unknown;
};

export const getUser = (params: URLSearchParams) => api.get<UserResponse>(
  `${GET_USER_URL}?${params.toString()}`
);
